
define(
	'C3.ShoppingExtensionsLatest.EntryPointFolder'
,   [
		'C3.ShoppingExtensions.HomeHeader',
		'C3.ShoppingExtensions.IncomingEquipment',
		'C3.ShoppingExtensions.NewArrivals',
		'C3.ShoppingExtensions.PDP',
		'C3.ShoppingExtensions.CartPage',
		'C3.ShoppingExtensions.LoginRegister',
		'C3.ShoppingExtensions.ViewInventory',
		'C3.ShoppingExtensions.InventoryList',
		'C3.ShoppingExtensions.PLP',
		'C3.ShoppingExtensions.SignUp',
		'C3.ShoppingExtensions.NewsletterSignup',
		'C3.ShoppingExtensions.ReceiveUpdates',
//		'C3.ShoppingExtensions.MeetTeam'
	]
,   function (
		HomeHeaderExtension,
		IncomingEquipmentModule,
		NewArrivalsModule,
		PDPModule,
		CartModule,
		LoginModule,
		ViewInventory,
		InventoryList,
		PLPModule,
		SignUpModule,
		NewsletterSignup,
		ReceiveUpdates,
	//	MeetOurTeam
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			
			HomeHeaderExtension.mountToApp(container);
			IncomingEquipmentModule.mountToApp(container);
			NewArrivalsModule.mountToApp(container);
			PDPModule.mountToApp(container);
			CartModule.mountToApp(container);
			LoginModule.mountToApp(container);
			ViewInventory.mountToApp(container);
			InventoryList.mountToApp(container);
			PLPModule.mountToApp(container);
			SignUpModule.mountToApp(container);
			NewsletterSignup.mountToApp(container);
			ReceiveUpdates.mountToApp(container);
			//MeetOurTeam.mountToApp(container);
		}
	};
});
